import React, { memo } from 'react';
import {Navigate, Outlet, useLocation, useNavigate} from 'react-router-dom';

const ProtectedRoute = memo(({ user, requiredRole }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const hasRequiredRole = () => {
        if (!user) return false;
        if (Array.isArray(requiredRole)) {
            return requiredRole.includes(user.user_type) || user.role === 'superadmin';
        }
        return user.user_type === requiredRole || user.role === 'superadmin';
    };

    if(location.pathname.includes('reset-password')){
        //return navigate(location.pathname+location.search);
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRole && !hasRequiredRole()) {
        return <Navigate to="/unauthorized" replace />;
    }

    return <Outlet />;
});

export default ProtectedRoute;
